import {BaseModel}                                from '@shared/models/base.model';
import {FileType, PaymentStatusEnum, PaymentType} from '@generated/graphql';
import {Country}                                  from '@modules/country/models/country.model';
import {Payable}                                  from '@modules/payment/models/payable.model';
import {PaymentDetail}                            from '@modules/payment/models/payment-detail.model';
import {paymentDetailFactory}                     from '@modules/payment/factories/payment-detail.factory';
import {countryFactory}                           from '@modules/country/factories/country.factory';
import {AppStatusType}                            from "@shared/component/common/status/status.component";
import {PaymentProvider}                          from "@modules/payment/models/payment-provider.model";
import {PaymentType as PaymentTypeModel}          from "@modules/payment/models/payment-type.model";
import {User}                                     from "@modules/user/models/user.model";
import {userFactory}                              from "@modules/user/factories/user.factory";
import {paymentProviderFactory}                   from "@modules/payment/factories/payment-provider.factory";
import {orderFactory}                             from "@modules/order/factories/order.factory";
import {CallOutStyle}                             from "@shared/component/message/callout/callout.component";
import {startCase}                                from 'lodash-es';


export class Payment extends BaseModel implements PaymentType {
    id: string;
    amount: number;
    currency: string;
    statusLabel: string;
    detail: PaymentDetail;
    payable: Payable;
    payableCountry: Country;
    canMakePayment: boolean;
    payableType: string;
    status: PaymentStatusEnum;
    paymentProvider: PaymentProvider;
    paymentType: PaymentTypeModel;
    user: User;
    proofOfPayment: FileType;
    receiptUrl: string;
    canGetReceiptUrl: boolean;
    isBilling: boolean;
    isPaymentToDo: boolean;
    isReviewingPayment: boolean;
    isPaid: boolean;
    showProofOfPayment: boolean;
    _model: string;
    protected _isLoading: boolean;

    constructor(state: PaymentType) {
        super(state);

        this.detail = state.detail ? paymentDetailFactory.create(state.detail) : null;

        this.payable = state.payable ? orderFactory.create(state.payable) : null;

        this.payableCountry = state.payableCountry ? countryFactory.create(state.payableCountry) : null;

        this.user = state.user ? userFactory.create(state.user) : null;

        this.paymentProvider = state.paymentProvider ? paymentProviderFactory.create(state.paymentProvider) : null;
    }

    set loading(loading: boolean) {
        this._isLoading = loading;
    }

    get loading(): boolean {
        return this._isLoading;
    }

    setLoading(loading: boolean): BaseModel {
        this.loading = loading;

        return this;
    }

    getModelName(): string {
        return Payment.name;
    }

    public renderStatusStyle(): AppStatusType {
        switch (this.status) {
            case PaymentStatusEnum.Billing:
                return "purple";
            case PaymentStatusEnum.PaymentToDo:
                return "warn";
            case PaymentStatusEnum.ReviewingPayment:
                return "warn";
            case PaymentStatusEnum.Paid:
                return 'success';
            case PaymentStatusEnum.Closed:
                return "cancelled";
            default:
                return 'default';
        }
    }

    public renderStatusLabel(): string {
        return this.statusLabel || startCase(this.status.toLowerCase());
    }

    public canViewProofOfPayment(): boolean {
        return (!!this.showProofOfPayment || !!this.proofOfPayment) && this.paymentProvider?.isWireTransfer();
    }

    public canViewPaymentReceipt(): boolean {
        return this.status === PaymentStatusEnum.Paid && !!this.canGetReceiptUrl;
    }
}
